import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Empty } from "@/components/ui-helpers";

const inr = (n) => "₹" + Math.round(n || 0).toLocaleString("en-IN");

export default function Ads() {
  const [overview, setOverview] = useState(null);
  const [lib, setLib] = useState(null);
  const [q, setQ] = useState("");
  const [days, setDays] = useState(30);

  useEffect(() => { api.get("/ads/overview", { params: { days } }).then((r) => setOverview(r.data)); }, [days]);
  useEffect(() => { api.get("/ads/library", { params: { q: q || undefined } }).then((r) => setLib(r.data)); }, [q]);

  return (
    <div data-testid="ads-page">
      <PageHeader
        title="Ads"
        sub="T&T lead-gen campaigns only · configured by include rule in Settings"
        right={
          <select
            value={days}
            onChange={(e) => setDays(Number(e.target.value))}
            className="text-xs px-2 py-1 rounded border"
            data-testid="ads-window-select"
          >
            <option value={7}>Last 7d</option>
            <option value={30}>Last 30d</option>
            <option value={90}>Last 90d</option>
          </select>
        }
      />

      <div className="p-4 md:p-6 space-y-6">
        <section>
          <h2 className="text-sm font-medium mb-3">Overview</h2>
          {!overview ? <div className="text-xs text-neutral-500">Loading…</div> : (
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-2" data-testid="ads-kpis">
              {[
                ["Spend", inr(overview.spend)],
                ["Impressions", (overview.impressions || 0).toLocaleString("en-IN")],
                ["Clicks", (overview.clicks || 0).toLocaleString("en-IN")],
                ["Leads", overview.leads || 0],
                ["Qualified", overview.qualified || 0],
                ["QCPL", overview.qcpl ? inr(overview.qcpl) : "—"],
                ["Rev/₹", overview.revenue_per_rupee ?? "—"],
              ].map(([l, v]) => (
                <div key={l} className="panel p-3">
                  <div className="text-[10px] uppercase tracking-wider text-neutral-500">{l}</div>
                  <div className="text-lg font-medium mt-1 font-mono">{v}</div>
                </div>
              ))}
            </div>
          )}
        </section>

        <section>
          <h2 className="text-sm font-medium mb-3">Spend plans (monthly)</h2>
          {!overview?.spend_plans?.length ? (
            <Empty label="No spend plans yet. Add rows in Phase 4." />
          ) : (
            <div className="panel overflow-x-auto">
              <table className="table-dense w-full">
                <thead className="border-b border-[var(--border)]">
                  <tr><th className="px-3 py-2 text-left">Month</th><th className="px-3 py-2 text-left">Planned</th><th className="px-3 py-2 text-left">Actual</th></tr>
                </thead>
                <tbody>
                  {overview.spend_plans.map((p) => (
                    <tr key={p.month} className="border-b border-[var(--border)]">
                      <td className="px-3 py-2 font-mono">{p.month}</td>
                      <td className="px-3 py-2">{inr(p.planned)}</td>
                      <td className="px-3 py-2">{inr(p.actual)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>

        <section>
          <div className="flex items-center justify-between mb-3 gap-2">
            <h2 className="text-sm font-medium">Ad library</h2>
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search name / copy…"
              className="text-xs px-3 py-1.5 rounded border w-64"
              data-testid="ads-search"
            />
          </div>
          {!lib ? <div className="text-xs text-neutral-500">Loading…</div> : lib.rows.length === 0 ? (
            <Empty label="No ads cached. Connect Meta Ads in Settings → Integrations and run a backfill." />
          ) : (
            <div className="panel overflow-x-auto">
              <table className="table-dense w-full">
                <thead className="border-b border-[var(--border)]">
                  <tr>
                    <th className="px-3 py-2 text-left">Ad</th>
                    <th className="px-3 py-2 text-left">Status</th>
                    <th className="px-3 py-2 text-left">Created</th>
                    <th className="px-3 py-2 text-left">Spend</th>
                    <th className="px-3 py-2 text-left">Qualified</th>
                    <th className="px-3 py-2 text-left">QCPL</th>
                  </tr>
                </thead>
                <tbody>
                  {lib.rows.map((a) => (
                    <tr key={a.ad_id} className="border-b border-[var(--border)]">
                      <td className="px-3 py-2 max-w-sm truncate">{a.name}</td>
                      <td className="px-3 py-2">{a.status}</td>
                      <td className="px-3 py-2 font-mono text-neutral-400">{a.created_time?.slice(0, 10)}</td>
                      <td className="px-3 py-2 font-mono">{inr(a.spend)}</td>
                      <td className="px-3 py-2 font-mono">{a.qualified || 0}</td>
                      <td className="px-3 py-2 font-mono">{a.qcpl ? inr(a.qcpl) : "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
